import { StatusBar } from 'expo-status-bar';
import React from 'react';
import ReactDOM from "react-dom";
import { StyleSheet, Text, View } from 'react-native';
//import { SplitViewWindows } from 'react-native-windows';
import Login from './invoiceJS/login.js';
import Invoice from './invoiceJS/invoice.js';
import UserProfile from './invoiceJS/userProfile';
import styles from './invoiceCSS/style.css';

export default function App() {
  return (
    <View>
      <div id='invoiceShow'>
      </div>
    </View>
  );
}

function LoginShhow() {
  setTimeout(function () {
    ReactDOM.render(
      <Login name="Azonosítás szükséges" value="Belépés" />,
      document.getElementById("invoiceShow")
    );
  }, 1000);
}

function invoiceShow() {
  setTimeout(function () {
    ReactDOM.render(
      <Invoice />,
      document.getElementById("invoiceShow")
    );
  }, 1000);
}

if (UserProfile.getHashName() === '') {
  LoginShhow();
} else {
  invoiceShow();
}